'use strict';

angular.module('client.components').component('xpReportPicker', {
  template: require('./reportPicker.jade'),
  controller: ['$scope', 'ActiveMode', 'User', 'SchoolAdminMode', 'SubscriptionMode', 'DistrictAdminMode',
    function ($scope, ActiveMode, User, SchoolAdminMode, SubscriptionMode, DistrictAdminMode) {
      this.userId = User.getId();

      this.isCurriculumMode = function () {
        return ActiveMode.isCurriculumMode();
      };

      this.isClassMode = function () {
        return ActiveMode.isClassMode();
      };

      this.isSubscriptionMode = function () {
        return SubscriptionMode.isActiveMode();
      };

      this.currentClassId = function () {
        return ActiveMode.currentClassId();
      };

      this.isSchoolAdminMode = function () {
        return SchoolAdminMode.isActiveMode();
      };

      this.isDistrictAdminMode = function () {
        return DistrictAdminMode.isActiveMode();
      };

      this.currentDistrictId = function () {
        return ActiveMode.currentDistrictId();
      };

      this.currentSchoolId = function () {
        return ActiveMode.currentSchoolId();
      };

      this.currentSubscriptionId = function () {
        return ActiveMode.currentSubscriptionId();
      };

      this.onReportSelect = function (reportId, reportSubscriptionId) {
        $scope.$applyAsync(function () {
          if (SchoolAdminMode.isActiveMode() || DistrictAdminMode.isActiveMode()) {
            // Admin report definitions can belong to a different subscription than the list route.
            SubscriptionMode.showDistrictReport(reportSubscriptionId, reportId);
          } else {
            ActiveMode.showReport(reportId);
          }
        });
      };
    }],
});
